// @flow
/** @jsx jsx */

import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import { css, jsx } from '@emotion/core';

import LabelCell from './LabelCell';
import FormRow from './FormRow';
import DescriptionCell from './DescriptionCell';
import InputField from './InputField';
import { DesktopView, MobileView, useMobileMediaQuery } from '../config/mediaQuery';

type Props = {
  value?: string | number,
  label: string,
  name?: string,
  readOnly?: boolean,
  type?: string,
  isValidating?: boolean,
  disabled?: boolean,
  kind?: 'money' | '',
  className?: any,
  inline: Boolean,
  counterButtons: Boolean,
  setFieldValue: () => {},
  values: [],
};

const withErrorsClass = css`
  margin-bottom: 15px;
`;

const clsWithMoney = css`
  &::before {
    content: '$ ';
    position: absolute;
    top: 13px;
    left: 17px;
  }

  & input {
    padding-left: 25px;
  }
`;
const clsWithMoneyMobile = css`
  &::before {
    content: '$ ';
    position: absolute;
    top: 8px;
    left: 17px;
  }

  & input {
    padding-left: 25px;
  }
`;

const base = css`
  position: relative;
`;

const SingleField = (props: Props) => {
  const { label, kind, inline, counterButtons, setFieldValue, values, ...rest } = props;
  const isMobile = useMobileMediaQuery();

  return (
    <FormRow css={[!props.readOnly && !isMobile && withErrorsClass, { ...(isMobile && { alignItems: 'center' }) }, { ...(!inline && isMobile && { display: 'flex', flexDirection: 'column' }) }]}>
      <DesktopView>
        <LabelCell>
          <ControlLabel>{label}</ControlLabel>
        </LabelCell>
      </DesktopView>
      <MobileView>
        <div className='input-label' style={{ ...(!inline && { width: '100%', textAlign: 'left' }) }}>
          {label}
        </div>
      </MobileView>
      <DesktopView>
        <DescriptionCell css={[base, kind === 'money' && clsWithMoney]}>
          {props.readOnly ? (
            <FormControl {...rest} />
          ) : (
            <InputField
              {...rest}
              css={[
                base,
                {
                  margin: 0,
                },
              ]}
            />
          )}
        </DescriptionCell>
      </DesktopView>
      <MobileView>
        <DescriptionCell css={[base, kind === 'money' && clsWithMoneyMobile, { ...(!inline && { width: '100%' } )}]}>
          <div className={counterButtons && 'counter-buttons-input'}>
            {isMobile && counterButtons && setFieldValue &&
              <button type='button' className='counter-buttons' onClick={() => {
                const fieldValue = values[props.name];
                if (fieldValue > 0) {
                  setFieldValue(props.name, fieldValue - 1, true)
                }
              }}>
                -
              </button>
            }
            {props.readOnly ? (
              <FormControl {...rest} />
            ) : (
              <InputField
                {...rest}
                css={[
                  base,
                  {
                    margin: 0,
                  },
                ]}
              />
            )}
            {isMobile && counterButtons && setFieldValue &&
              <button type='button' className='counter-buttons' onClick={() => {
                const fieldValue = values[props.name];
                setFieldValue(props.name, fieldValue + 1, true);
              }}>
                +
              </button>
            }
          </div>
        </DescriptionCell>
      </MobileView>
    </FormRow>
  );
};

SingleField.defaultProps = {
  readOnly: true,
  type: 'text',
  value: '',
};

export default SingleField;
